import styled from 'styled-components';

export const StyledProtectRout = styled.section`
    margin: 0 outo;

    h1{
        text-align: center;
        font-size: 35px;
        color: var(--color-05);
        margin-top: 50px;
    }
`